import { defineComponent as t, openBlock as r, createBlock as l, unref as c, mergeProps as p, withCtx as m, createElementVNode as d } from "vue";
import { RevIcon as a } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconSend",
  __name: "IconSend",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (i, e) => (r(), l(c(a), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        d("path", {
          "fill-rule": "evenodd",
          d: "M5.856 4.924c-1.165-.453-2.2.897-1.46 1.905L8.196 12l-3.8 5.171c-.74 1.008.295 2.359 1.46 1.905l15.2-5.91c1.063-.414 1.063-1.918 0-2.33l-15.2-5.912m3.65 6.326L6.113 6.633l11.87 4.617H9.506m0 1.5-3.392 4.617 11.871-4.617h-8.48",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
